import { render, staticRenderFns } from "./ToothSelector.vue?vue&type=template&id=2b077dc5&scoped=true&"
import script from "./ToothSelector.vue?vue&type=script&lang=ts&"
export * from "./ToothSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ToothSelector.vue?vue&type=style&index=0&id=2b077dc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b077dc5",
  null
  
)

export default component.exports